import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Pencil, Trash2, Plus, X, Check, MapPin } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { inputCls, btnPrimary, btnGhost, cardCls } from "./styles";

const EMPTY = { name: "", eta: "", order: 0, visible: true };

export const AreasTab = () => {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(null);

  const load = () => api.get("/admin/areas").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (form.id) await api.put(`/admin/areas/${form.id}`, form);
      else await api.post("/admin/areas", form);
      toast.success("تم الحفظ");
      setForm(null);
      load();
    } catch (err) { toast.error(errMsg(err)); }
  };

  const del = async (id) => {
    if (!window.confirm("حذف هذه المنطقة؟")) return;
    try {
      await api.delete(`/admin/areas/${id}`);
      toast.success("تم الحذف");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-5">
        <div className="text-sm text-zinc-500">{items.length} منطقة</div>
        <button data-testid="area-add-btn" onClick={() => setForm({ ...EMPTY, order: items.length + 1 })} className={`${btnPrimary} flex items-center gap-1.5`}>
          <Plus className="w-4 h-4" /> إضافة منطقة
        </button>
      </div>

      {form && (
        <form data-testid="area-form" onSubmit={save} className={`${cardCls} mb-5 space-y-3 border-yellow-400/40`}>
          <div className="grid sm:grid-cols-2 gap-3">
            <input data-testid="area-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="اسم المنطقة * — مثال: شمال الرياض" className={inputCls} required />
            <input data-testid="area-eta-input" value={form.eta} onChange={(e) => setForm({ ...form, eta: e.target.value })} placeholder="مدة الوصول — مثال: 25 - 40 دقيقة" className={inputCls} />
          </div>
          <div className="flex flex-wrap items-center gap-4">
            <label className="flex items-center gap-2 text-sm text-zinc-400">
              الترتيب
              <input type="number" value={form.order} onChange={(e) => setForm({ ...form, order: Number(e.target.value) })} className={`${inputCls} w-20`} />
            </label>
            <label className="flex items-center gap-2 text-sm text-zinc-400">
              <input data-testid="area-visible-check" type="checkbox" checked={form.visible} onChange={(e) => setForm({ ...form, visible: e.target.checked })} className="accent-yellow-400 w-4 h-4" />
              ظاهرة في الموقع
            </label>
            <div className="flex gap-2 mr-auto">
              <button type="submit" data-testid="area-save-btn" className={`${btnPrimary} flex items-center gap-1.5`}><Check className="w-4 h-4" /> حفظ</button>
              <button type="button" onClick={() => setForm(null)} className={btnGhost}><X className="w-4 h-4" /></button>
            </div>
          </div>
        </form>
      )}

      <div className="space-y-3">
        {items.map((a) => (
          <div key={a.id} data-testid={`area-row-${a.id}`} className={`${cardCls} flex items-center gap-4`}>
            <span className="w-10 h-10 shrink-0 rounded-lg bg-yellow-400/10 border border-yellow-400/30 flex items-center justify-center text-yellow-400">
              <MapPin className="w-5 h-5" />
            </span>
            <div className="flex-1 min-w-0">
              <div className="font-bold text-white text-sm flex items-center gap-2">
                {a.name}
                {!a.visible && <span className="text-[10px] text-zinc-500 border border-zinc-700 rounded-full px-2 py-0.5">مخفية</span>}
              </div>
              <div className="text-xs text-zinc-500">{a.eta}</div>
            </div>
            <button data-testid={`area-edit-${a.id}`} onClick={() => setForm(a)} className="text-zinc-400 hover:text-yellow-400 p-1.5 transition-colors"><Pencil className="w-4 h-4" /></button>
            <button data-testid={`area-delete-${a.id}`} onClick={() => del(a.id)} className="text-zinc-400 hover:text-red-400 p-1.5 transition-colors"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
};
